import{getDefaultExportFromCjs as r}from"./_commonjsHelpers.mjs";import{__require as e}from"../international_street/Candidate.mjs";var t=r(e());export{t as default};
